import { useRouter } from "@tanstack/react-router";
import { Route as ContentRoute } from "#/app/routes/_umbraco/_content/_layout.tsx";
import { Route as PreviewRoute } from "#/app/routes/_umbraco/_preview/umbraco/_layout.tsx";

export function useGetSearchSettings() {
	const router = useRouter();
	const contentLoaderData = router.options.context.previewBlock
		? PreviewRoute.useLoaderData
		: ContentRoute.useLoaderData;

	return contentLoaderData().searchSettings;
}
